export const HASHTAG_TYPE = 'wix-draft-plugin-hashtag';
